import { FC } from "react";
import styled, { useTheme } from "styled-components";
import PageWrapper from "../components/common/PageWrapper";

const UnauthorizedScreenWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: normal;
	font-family: "Livvic";
	font-style: normal;
	font-weight: 700;
	font-size: 30px;
	line-height: 135%;
	height: 100vh;
	background-color: ${props => props.theme.colors.primary};
	color: #ffffff;
	gap: 20px;
`;

/**
 * ### Tela aviso falta de aturização
 * Tela genérica de falta de autorização, entra aqui caso o usuário tentar acessar algo que ele não pode.
 */
const UnauthorizedScreen: FC = () => {
	const theme = useTheme();

	return (
		<PageWrapper backgroundColor={theme.colors.primary}>
			<UnauthorizedScreenWrapper>
				<svg width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M112.983 0.342107C72.6053 4.64741 37.7659 26.9008 17.128 61.5677C9.01831 75.1544 3.87288 89.6925 1.07696 106.858C-0.321007 115.412 -0.37713 134.59 1.02083 143.203C6.8933 179.379 26.0209 209.348 55.9955 229.367C71.0951 239.432 88.488 246.142 107.11 248.994C116.003 250.335 134.626 250.335 143.182 248.994C161.973 245.974 179.085 239.376 194.019 229.367C223.94 209.407 243.177 179.211 248.994 143.203C250.335 134.648 250.335 116.029 248.994 107.138C243.458 71.0736 223.94 40.5436 193.573 20.4148C178.751 10.5749 161.919 4.08885 143.463 1.18124C136.697 0.117669 119.582 -0.384796 112.983 0.342107ZM133.396 21.0295C165.664 23.8249 194.075 40.5437 211.692 67.0463C244.017 115.524 230.652 180.721 181.94 212.48C150.901 232.665 111.251 234.79 77.7507 218.015C22.1051 190.171 3.5387 118.769 38.3807 66.8805C59.5185 35.4553 96.0951 17.7878 133.396 21.0295Z"
						fill="white"
					/>
					<path
						d="M73.7252 72.1907C68.9726 73.4761 65.169 75.713 61.4777 79.4036C50.6843 90.1949 50.7404 106.243 61.5899 117.034C72.1589 127.66 88.4319 127.604 99.0595 116.981C109.685 106.358 109.741 90.0852 99.1156 79.5184C92.1793 72.5273 82.6717 69.7881 73.7252 72.1907ZM83.7916 90.0291C89.5518 92.4343 90.9497 99.9252 86.4752 104.399C82.84 108.033 77.6946 108.033 74.0594 104.399C67.1257 97.52 74.7864 86.2263 83.7916 90.0291Z"
						fill="white"
					/>
					<path
						d="M163.093 72.2468C148.945 76.0496 140.164 90.7535 143.743 104.621C147.491 118.878 162.197 127.826 176.067 124.191C181.044 122.906 184.792 120.725 188.539 116.978C195.42 110.099 198.103 100.818 195.754 91.8732C192.006 77.3912 177.131 68.4439 163.093 72.2468ZM173.271 90.0291C179.032 92.4343 180.43 99.9252 175.955 104.399C169.692 110.717 159.402 105.07 161.024 96.2346C162.032 90.9779 168.182 87.8484 173.271 90.0291Z"
						fill="white"
					/>
					<path
						d="M114.383 161.375C96.2635 163.893 79.4293 171.608 65.9522 183.573L62.6537 186.48L68.8042 192.686C72.1588 196.04 75.1792 198.835 75.4599 198.835C75.7966 198.835 77.0262 197.827 78.3119 196.654C83.9599 191.176 93.9701 185.304 102.639 182.397C110.524 179.77 115.669 178.987 125.008 178.987C134.348 178.987 139.493 179.77 147.378 182.397C156.047 185.304 166.057 191.176 171.705 196.654C172.991 197.83 174.223 198.835 174.557 198.835C174.838 198.835 177.856 196.04 181.213 192.686L187.363 186.48L184.065 183.573C178.136 178.316 171.259 173.733 163.876 170.098C151.236 163.837 141.45 161.431 127.246 161.097C122.156 160.982 116.396 161.095 114.383 161.375Z"
						fill="white"
					/>
				</svg>
				Sem autorização para essa rota
			</UnauthorizedScreenWrapper>
		</PageWrapper>
	);
};

export default UnauthorizedScreen;
